import axios from "axios";
import mergeDeep from "../util/mergeDeep";
import getHeadersWithToken from "./authenticationHelper";

const defaultHeaders = {
    'accept': 'application/json'
};

const httpRequestWrapper = {
    get(url, customHeader) {
        let headers = mergeDeep({}, defaultHeaders);

        if(customHeader)
            headers = mergeDeep(defaultHeaders, customHeader);

        return getHeadersWithToken().then(authenticationHeader => {
            return axios.get(url, {headers: mergeDeep(headers, authenticationHeader)});
        });
    }, put(url, model, customHeader) {
        let headers = mergeDeep({}, defaultHeaders);
        if(customHeader)
            headers = mergeDeep(defaultHeaders, customHeader);

        return getHeadersWithToken().then(authenticationHeader => {
            return axios.put(url, model, { headers: mergeDeep(headers, authenticationHeader)});
        });
    }, post(url, model, customHeader) {
        let headers = mergeDeep({}, defaultHeaders);

        if(customHeader)
            headers = mergeDeep(defaultHeaders, customHeader);

        return getHeadersWithToken().then(authenticationHeader => {
            return axios.post(url, model, { headers: mergeDeep(headers,authenticationHeader)});
        });
    }, delete(url, customHeader) {
        let headers = mergeDeep({},defaultHeaders);

        if(customHeader)
            headers = mergeDeep(defaultHeaders,customHeader);

        return getHeadersWithToken().then(authenticationHeader => {
            return axios.delete(url, { headers: mergeDeep(headers, authenticationHeader)});
        });
    }
};

 export default httpRequestWrapper;